import axiosInstance from "../axios/axios-configuration";
import { CancelToken } from "axios";

const controller = 'Exhibitions';

const insertExhibitionAuditOperation = (aooId: number, protocolId: number, filename: string, uorId: number | undefined, cancelToken?: CancelToken): Promise<any> => {

    return axiosInstance.get(`${controller}/${aooId}/InsertExhibitionAuditOperation/${protocolId}`, { params: { filename, uorId }, cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}


export default {
    insertExhibitionAuditOperation
}

